import { ContactUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/crm/v1/contact_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

type ContactUpdatedDetailProps = {
  event: ContactUpdatedEvent;
};

export const ContactUpdatedDetail = ({ event }: ContactUpdatedDetailProps) => {
  const previous = event.previousContact;
  const current = event.updatedContact;

  if (!previous || !current) {
    return (
      <Col className="@ContactUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'fullName',
      label: 'Full Name',
      previous: previous.fullName,
      current: current.fullName,
    },
    {
      field: 'email',
      label: 'Email',
      previous: previous.email,
      current: current.email,
    },
    {
      field: 'phone',
      label: 'Phone',
      previous: previous.phone,
      current: current.phone,
    },
    {
      field: 'role',
      label: 'Role',
      previous: previous.role,
      current: current.role,
    },
    {
      field: 'department',
      label: 'Department',
      previous: previous.department,
      current: current.department,
    },
    {
      field: 'prefix',
      label: 'Prefix',
      previous: previous.prefix,
      current: current.prefix,
    },
    {
      field: 'addressAs',
      label: 'Address As',
      previous: previous.addressAs,
      current: current.addressAs,
    },
    {
      field: 'isPrimary',
      label: 'Is Primary',
      previous: previous.isPrimary ? 'Yes' : 'No',
      current: current.isPrimary ? 'Yes' : 'No',
    },
    {
      field: 'notes',
      label: 'Notes',
      previous: previous.notes,
      current: current.notes,
    },
  ];

  return (
    <Col className="@ContactUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Contact</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Full Name" value={current.fullName} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
